module.exports = require("./dist/recorder.js");



//////////////////
// WEBPACK FOOTER
// ./~/js-audio-recorder/index.js
// module id = 374
// module chunks = 13